import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet'

// variables
import { SITENAME } from '../../configuration.js';


export default function Page403(props){


  //
  //
  return (
    <Fragment>
      <Helmet>
        <title>403 access denied | { SITENAME }</title>
      </Helmet>

      <div className="container py-5">
        <div className="ErrorPage d-flex flex-column align-items-start">
          <h1 style={{fontSize:'52px'}}>403 <small style={{fontSize:'18px'}}>Access denied</small></h1>
          <p>You don't have permission to access requested page.</p>
          <a href="/" className="button accent">Back to the Dashboard</a>
        </div>
      </div>

    </Fragment>
  );

}
